import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';

@Directive({
  selector: '[ifMasterBo]',
})
export class IfMasterBoDirective implements OnInit {
  @Input('ifMasterBo') profile: boolean;

  constructor(
    private el: ElementRef,
    private profileService: ProfileManagerService,
  ) {}
  ngOnInit() {
    if (!this.profileService.isMasterBO())
      this.el.nativeElement.style.display = 'none';
  }
}
